jQuery(document).ready(function($) {
    var is_loading = false;
    var cur_page = 1;

    function load_posts() {
        cur_page++;
        var url = '/api/get-posts.php?paged=' + cur_page;

        if (wp_data.category) { // localized in functions.php
            url = url + '&category_id=' + wp_data.category;
        }

        $.get(url, function(data) {
            // console.log(data);
            $('#post-shell').append(data.content);

            if (data.last_page) {
                $('#preloader-shell').remove();
            }

            is_loading = false;
        });
    }

    var $preloader_shell = $("#preloader-shell");

    $(window).scroll(function(e) {
        var scrollY = $(window).scrollTop();

        if ($preloader_shell.length) {
            var preloader_offset = $('#preloader-shell').offset().top;

            if ((scrollY + $(window).innerHeight()) > preloader_offset && is_loading === false) {
                load_posts();
                is_loading = true;
            }
        }
    });
    $(window).scroll();
});



// WEBPACK FOOTER //
// ./src/js/app/scroll.js